import { render, staticRenderFns } from "./LatestActivities.vue?vue&type=template&id=64f7cfbd&scoped=true"
import script from "./LatestActivities.vue?vue&type=script&lang=js"
export * from "./LatestActivities.vue?vue&type=script&lang=js"
import style0 from "./LatestActivities.vue?vue&type=style&index=0&id=64f7cfbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f7cfbd",
  null
  
)

export default component.exports